<script setup lang="ts">
import { useBetbook } from "~/store/betbook";
import EventMarket from "~/components/layout/TrackRacing/Shared/Market/EventMarket.vue";
import Loader from "./Loader.vue";
import t from "~/utils/translate";
const store = useBetbook();

interface Props {
	isLoading: boolean | undefined;
}
defineProps<Props>();
const outrightMarket = computed(() => {
	const markets = [...store.markets.values()];
	let market = markets.find((m) => m.name === "[Ante Post Race]");

	if (!market) market = markets.find((m) => m.name === "[Ante Post Final Declarations]");

	if (!market) market = markets.find((m) => m.name === "[Ante Post Race Non Runner No Bet]");
	return market;
});

const outcomes = computed(() => {
	return [...store.outcomes.values()].filter(({ marketId, shouldDisplay }) => marketId === outrightMarket.value?.marketId && shouldDisplay);
});
</script>
<template>
	<Loader v-if="isLoading" />
	<div v-else-if="!isLoading && outcomes.length > 0" class="bg-light-50 dark:bg-dark-800 rounded-lg">
		<div class="grid grid-cols-[auto_55px] items-center p-1 text-xs font-bold min-h-[34px] bg-dark-800 dark:bg-dark-700 rounded-t-lg text-light-50">
			<div class="px-1">{{ t("name") }}</div>
			<div class="text-center">{{ t("win") }}</div>
		</div>
		<div
			v-for="(outcome, index) in outcomes"
			:key="outcome.outcomeId"
			:class="index + 1 !== outcomes?.length ? `border-b border-b-light-400 dark:border-b-dark-500` : null"
		>
			<div class="grid grid-cols-[auto_55px] items-center p-1 text-xs">
				<div class="font-bold px-1">
					{{ outcome.displayName }}
				</div>
				<div class="flex justify-center">
					<EventMarket :event-id="outcome.eventId" :outcome="outcome" :market="outrightMarket" :key="`${outcome.eventId}`" />
				</div>
			</div>
		</div>
	</div>
	<div v-else class="w-full rounded-lg bg-light-50 dark:bg-dark-800 text-xs text-center font-bold my-2 py-2">
		{{ t("horses-no-markets-message") }}
	</div>
</template>
